module.exports = __webpack_public_path__ + "img/logo_bg.abb10edf.png";